import type { StoreProductResult } from "../services/ProductSearchService";
import type { AddLeadRequest } from "../services/LeadsService";

export type LeadCategoryMode = "product" | "preset" | "custom";

export const resolveLeadCategory = (input: {
  categoryMode: LeadCategoryMode;
  product: StoreProductResult;
  customCategory: string;
  presetCategory: string;
}) => {
  if (input.categoryMode === "custom") {
    return input.customCategory.trim();
  }
  if (input.categoryMode === "preset") {
    return input.presetCategory.trim();
  }
  return input.product.mainCategory || input.product.categoryPath || "Uncategorized";
};

export const isLeadCategoryInputValid = (
  categoryMode: LeadCategoryMode,
  customCategory: string,
  presetCategory: string
) => {
  if (categoryMode === "custom") return customCategory.trim().length > 0;
  if (categoryMode === "preset") return presetCategory.trim().length > 0;
  return true;
};

/** Retailer key used for lead storage and Discord channel lookups. walmart_online shares Walmart's leads. */
export const leadRetailerFor = (retailer: string) => {
  const r = (retailer || "").trim().toLowerCase();
  return r === "" || r === "walmart_online" ? "walmart" : r;
};

export const buildLeadRequest = (input: {
  product: StoreProductResult;
  category: string;
  retailer: string;
}) => {
  const { product, category } = input;
  const leadData: AddLeadRequest = {
    retailer: leadRetailerFor(input.retailer),
    upc: product.sku || "",
    sku: product.barcode || "",
    category,
    lowestPrice: product.storePrice || 0,
    msrp: product.msrp || 0,
    onlinePrice: product.onlinePrice || 0,
    image: product.image || "",
    title: product.name || "",
    brand: product.brand || "",
  };
  return leadData;
};
